import { Head, usePage } from "@inertiajs/react"
import { SettingsPage } from "@/components/settings/SettingsPage"
import type { FrontMatterField, RoutingRule, UserSettings } from "@/components/settings/SettingsPage"

interface SettingsProps {
  settings: UserSettings
  frontMatterFields: FrontMatterField[]
  routingRules: RoutingRule[]
  hasApiToken: boolean
  baseUrl: string
}

interface SharedProps {
  currentUser: { id: number; name: string; email: string } | null
  dropboxConnected: boolean
}

export default function Settings() {
  const { settings, frontMatterFields, routingRules, hasApiToken, baseUrl } = usePage<{ props: SettingsProps }>().props as unknown as SettingsProps
  const { currentUser, dropboxConnected } = usePage<{ props: SharedProps }>().props as unknown as SharedProps

  return (
    <>
      <Head title="Settings" />
      <SettingsPage
        settings={settings}
        frontMatterFields={frontMatterFields}
        routingRules={routingRules}
        dropboxConnected={dropboxConnected}
        hasApiToken={hasApiToken}
        baseUrl={baseUrl}
        email={currentUser?.email || ""}
      />
    </>
  )
}
